import { render, staticRenderFns } from "./automaticRules.vue?vue&type=template&id=10a41e67&scoped=true"
import script from "./automaticRules.vue?vue&type=script&lang=js"
export * from "./automaticRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a41e67",
  null
  
)

export default component.exports